import { Box, Typography, Container } from '@mui/material';
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import banner3 from '../../../assets/banner3.jpg';
import { useTheme as useAppTheme } from '../../../contexts/ThemeContext';

const AboutHeroSection = () => {
  const [offsetY, setOffsetY] = useState(0);
  const handleScroll = () => setOffsetY(window.scrollY);
  const boxRef = useRef<HTMLDivElement>(null);
  const { mode } = useAppTheme();

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Dynamic overlay color based on theme
  const getOverlayColor = () => {
    return mode === 'dark' ? 'rgba(24, 24, 24, 0.7)' : 'rgba(0, 0, 0, 0.5)';
  };

  return (
    <Box
      ref={boxRef}
      sx={{
        position: 'relative',
        height: '60vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
      }}
    >
      {/* Parallax Background Image */}
      <Box
        component="div"
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundImage: `url(${banner3})`,
          backgroundSize: 'cover',
          backgroundPosition: `center ${offsetY * 0.3}px`,
          backgroundRepeat: 'no-repeat',
          zIndex: 1,
          transition: 'background-position 0.2s',
        }}
      />
      {/* Overlay for readability */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          bgcolor: getOverlayColor(),
          zIndex: 2,
        }}
      />
      <Container maxWidth="lg" sx={{ position: 'relative', zIndex: 3 }}>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <Typography 
            variant="h1" 
            component="h1" 
            align="center"
            sx={{ 
              fontSize: { xs: '2.5rem', md: '4rem' },
              fontWeight: 700,
              color: 'white',
              mb: 2
            }}
          >
            About Us<Typography variant="h1" component="span" sx={{ color: 'secondary.main' }}>.</Typography>
          </Typography>
        </motion.div>
      </Container>
    </Box>
  );
};

export default AboutHeroSection; 